<template>
  <div class="invitation">
    <common-title bcColor="" titleName="邀好友得奖金" :isAPPShow="true"></common-title>
    <div class="account">
      <div class="account_bg"></div>
      <div class="account_main">
        <div class="account__cash">
          <div class="account__cash-mine">
            <div @click="onViewTip">现金账户 <img
                src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/invitationCommission/invite_tip.png"
                alt=""></div>
            <div @click="onViewCashDetail">{{ formatMoney(accountInfo.accountAmount) }}</div>
          </div>
          <div class="rule" @click="onViewRule">活动规则</div>
        </div>
        <div class="account__info">
          <div class="account__info-item" @click="onViewWithdrawDetail">
            <div class="desc">
              可提现(元)<span><img
                src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/invitationCommission/invite_right.png"
                alt=""></span>
            </div>
            <div class="num">
              {{ formatMoney(accountInfo.withdrawAmount) }}
            </div>
          </div>
          <div class="account__info-item" @click="onViewFriendDetail">
            <div class="desc">
              累计好友(人)<span><img
                src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/invitationCommission/invite_right.png"
                alt=""></span>
            </div>
            <div class="num">
              {{ accountInfo.totalFriends || '0' }}
            </div>
          </div>
          <div class="account__info-item" @click="onViewFriendDetail">
            <div class="desc">
              累计购课(人)<span><img
                src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/invitationCommission/invite_right.png"
                alt=""></span>
            </div>
            <div class="num">
              {{ accountInfo.totalCourses || '0' }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="account_ad">
      <img :src="basicInfo.activityImg" alt="">
    </div>
    <van-overlay :show="showTip" @click="showTip = false">
      <div class="wrapper" @click.stop>
        <div class="wrapper__title">
          <span></span>
          <span>说明</span>
          <img @click="showTip = false"
            src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/invitationCommission/invite_close.png"
            alt="">
        </div>
        <div class="wrapper__content">您与好友购课30天后即可提现哦</div>
      </div>
    </van-overlay>
    <Share :basicInfo="basicInfo" :accountInfo="accountInfo"></Share>
  </div>
</template>
<script>
import { mapState } from 'vuex';
// eslint-disable-next-line import/no-cycle
import {
  reqInvitationInfo,
  reqUserAccount,
} from '@/api/invitationCommission';
import { formatMoney } from '@/utils/tools';

import CommonTitle from '@/components/header/CommonTitle.vue';
import Share from './components/ShareInvitation/index.vue';

export default {
  components: {
    CommonTitle,
    Share,
  },
  data() {
    return {
      basicInfo: {},
      accountInfo: {},
      showTip: false,
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  methods: {
    formatMoney,
    initPage() {
      if (!this.userInfo?.id) return;
      this.getUserAccount();
    },
    // 查看活动基本信息
    getInvitationInfo() {
      reqInvitationInfo().then((res) => {
        this.basicInfo = res;
      });
    },
    // 查看我的账户信息
    getUserAccount() {
      reqUserAccount().then((res) => {
        this.accountInfo = res;
      }).finally(() => {
        this.$toast.clear();
      });
    },
    onViewTip() {
      this.showTip = true;
    },
    onViewWithdrawDetail() {
      this.$router.push({
        path: '/invitation/withdrawDetail?back=back',
      });
    },
    // 查看现金账户明细
    onViewCashDetail() {
      this.$router.push({
        path: '/invitation/accountDetail?back=back',
      });
    },
    // 查看规则
    onViewRule() {
      this.$router.push({
        path: '/invitation/activeRule?back=back',
      });
    },
    // 查看好友明细
    onViewFriendDetail() {
      this.$router.push({
        path: '/invitation/friendDetail?back=back',
      });
    },
    openLogin() {
      if (!(this.$root.$data.isApp || this.$root.$data.miniprogram)) {
        const { path } = this.$route;
        this.$router.push({
          path: '/registrationLogin',
          query: { redirect: path },
        });
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    const token = window.localStorage.getItem('accessToken');
    if (token) {
      next(() => {
        console.log(11111)
      });
    } else {
      next((vm) => {
        vm.$root.openLogin('/invitation/index');
      });
    }
  },
  mounted() {
    document.title = '邀好友得奖金';
    this.$toast.loading({
      message: '加载中...',
      forbidClick: true,
      duration: 0,
    });
    this.getInvitationInfo();
    console.log('mounted');
    this.initPage();
    window.addEventListener('pageshow', (e) => {
      if (e.persisted) {
        console.log('pageshow');
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
          duration: 0,
        });
        document.title = '邀好友得奖金';
        this.initPage();
      }
    });
  },
  watch: {
    userInfo: {
      deep: true,
      handler(val) {
        if (!val?.id) {
          // 区分App和h5
          this.openLogin();
        } else {
          this.initPage();
        }
      },
    },
  },
};
</script>

<style scoped lang="scss">
.invitation {
  position: absolute;
  width: 100%;
  min-height: 100%;
  padding-top: 116px;
  overflow: hidden;
  background: #F7F8FC;

  .account {
    // position: fixed;
    // z-index: 10;
    width: 750px;
    // height: 417px;

    &_bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 373px;
      background-image: url('https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/invitationCommission/invite_bg.png');
      background-repeat: no-repeat;
      background-position: 0 -80px;
      background-size: 750px 453px;
    }

    &_main {
      // position: absolute;
      // bottom: 0;
      // left: 50%;
      position: relative;
      left: 50%;
      z-index: 11;
      width: 678px;
      // height: 301px;
      padding: 33px 36px 36px;
      background: #FFF;
      background-image: url('https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/invitationCommission/invite_main_top.png');
      background-repeat: no-repeat;
      background-size: 678px 89px;
      border-radius: 25px;
      transform: translateX(-50%);

      .account__cash {
        display: flex;
        justify-content: space-between;
        height: 153px;

        &-mine {
          & div:first-child {
            width: 145px;
            height: 36px;
            color: #333;
            font-weight: 500;
            font-size: 25px;
            font-style: normal;
            line-height: 36px;
            text-align: left;

            img {
              display: inline-block;
              width: 22px;
              height: 22px;
            }
          }

          & div:last-child {
            width: 246px;
            height: 112px;
            margin-top: 5px;
            color: #FF7F41;
            font-weight: 600;
            font-size: 80px;
            font-style: normal;
            line-height: 112px;
            text-align: left;
          }
        }

        .rule {
          width: fit-content;
          height: 31px;
          color: #FF7F41;
          font-weight: 500;
          font-size: 22px;
          font-style: normal;
          line-height: 31px;
          text-align: left;
        }
      }
    }

    &__info {
      display: flex;

      &-item {
        width: 225px;

        &:last-child {
          flex: 1;
        }

        .desc {
          height: 31px;
          color: #999;
          font-weight: 400;
          font-size: 22px;
          font-style: normal;
          line-height: 31px;
          text-align: left;

          span {
            position: relative;
            top: -2px;
            display: inline-block;
            width: 10px;
            height: 10px;
            margin-left: 7px;
            img {
              width: auto;
              height: 10px;
            }
          }
        }

        .num {
          height: 40px;
          margin-top: 4px;
          color: #333;
          font-weight: 600;
          font-size: 29px;
          font-style: normal;
          line-height: 40px;
          text-align: left;
        }
      }
    }

    &_ad {
      padding: 29px 36px 196px;

      img {
        display: block;
        width: 100%;
        border-radius: 14px;
      }
    }
  }

  ::v-deep .commonTitle {
    background-image: url('https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/invitationCommission/invite_bg.png');
    background-repeat: no-repeat;
    background-size: 750px 453px;
  }

  ::v-deep .commonTitle .backButton {
    background-image: url('https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-question-bank/white-back.png');
    background-repeat: no-repeat;
    background-size: 100%;
  }

  ::v-deep .commonTitle .titleName {
    color: #fff;
  }

  ::v-deep .van-overlay {
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .wrapper {
    width: 634px;
    height: 259px;
    padding: 31px 33px 0;
    background: #FFF;
    border-radius: 36px;

    &__title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 40px;
      color: #333;
      font-weight: 500;
      font-size: 29px;
      font-style: normal;
      line-height: 40px;
      text-align: center;

      span {
        font-weight: 500;
        &:nth-child(1) {
          width: 29px;
          height: 29px;
        }
      }

      & img {
        display: inline-block;
        width: 29px;
        height: 29px;
      }
    }

    &__content {
      height: 43px;
      margin-top: 62px;
      color: #333;
      font-weight: 400;
      font-size: 29px;
      font-style: normal;
      line-height: 43px;
      text-align: center;
    }
  }
}
</style>
